import { useTranslation } from "react-i18next";
import { TextInputControllerType1 } from "../controller/TextInputControllerType1";
import CSSClassSerivce from "../../../../services/CommonCSSSerivce";
import InputValidationFactory from "../../../../factorys/inputvalidation/InputValidationFactory";
import { IInputValidationItemProps, IInputValidatorItem } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";
import { InputValidation } from "../../../../factorys/inputvalidation/InputValidation";

interface TextAreaInputProps extends IInputValidationItemProps {
  id?: string;
  testId?: string;
  readOnly?: boolean;
  required?: boolean;
  name: string | undefined;
  classNameRoot: string;
  classNameInput: string;
  disabledAddClass: string;
  defaultValue: string | undefined;
  placeholder: string | undefined;
  onInputChange?: ((it: string) => void) | null;
  disabled?: boolean | undefined;
  validationItems?: IInputValidatorItem[] | null;
}

const TextAreaInputType1: React.FC<TextAreaInputProps> = (props) => {

  const tag = "TextAreaInputType1"
  console.log(tag + " START")
  const { t } = useTranslation();

  let c = TextInputControllerType1({
    defaultValue: props.defaultValue, disabled: props.disabled,
    classNameFrame: "h-full",
    classNameInput: props.classNameInput, disabledClass: props.disabledAddClass,
  })


  const ivc = InputValidationFactory.getInputValidationController({
    validationItems: props.validationItems,
    itemProps: props,
    itemController: c,
    onMount: () => {
      ivc?.validate({ value: props.defaultValue, ignoreBlur: false })
    }
  });

  let key = props.defaultValue;

  return (
    <div className={props.classNameRoot}>
      <label htmlFor={props.name} className={CSSClassSerivce.labelClass}>
        <p> {t(props.name ? props.name : "")} </p>
        <p className="pl-0">{props.required ? " *" : ""}</p>
      </label>
     
      <div
        ref={(it) => c.setRefDiv(it)} >
        <textarea
          id={props.id}
          data-testid={props.testId}
          readOnly={props.readOnly ? props.readOnly : false}
          required={props.required ? props.required : false}
          key={key} //hint: keychange triggers input to reRender
          ref={c.refInputArea}
          className={props.classNameInput}
          name={props.name}
          defaultValue={props.defaultValue}
          placeholder={props.placeholder ? t(props.placeholder) : undefined}
          onFocus={(e) => {
            c.setFocused(true)
            //props.fOnFocus?props.fOnFocus():null
          }}
          onBlur={(e) => {
            c.setFocused(false)
            ivc?.strValidationIsVisible(e.target.value)
            //props.fOnBlur?props.fOnBlur():null
            c.setBlur(true)
          }}
          //value={c.value}
          onChange={(e) => {
            try {
              //console.log("e.target.defaultValue: "+e.target.value)

              ivc?.validate({ value: e.target.value });
              props.onInputChange ? props.onInputChange(e.target.value) : {}
            } catch (e) { }
          }}
        />
      </div>

      {(ivc != null) ? <InputValidation ivc={ivc} /> : <></>}
    </div>
  );
};

export default TextAreaInputType1;